import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import {
  sizeFont,
  sizeFontReals,
  families,
} from "../../../shared/utils/constants/sizeFonts";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import BackgroundColor from "../backgroungColor/backgroundColor";
import arrowDown from "../../../shared/images/arrow-down.svg";
import SelectLSC from "../../components/selectLSC/selectLSC";
import ButtonSelect from "../buttonSelect/buttonSelect";

const convertToHex = (color) => {
  if (color) {
    return color.startsWith("#") ? color : `#${color}`;
  }
  return null;
};

const TextEditor = (props) => {
  const {
    playerNameStyles,
    fontWeight,
    handleChangeComplete,
    selectBold,
    handleOnSelect,
    background,
    handleChangeBackground,
    backgroundLabel,
    stylesLabel,
    text,
    onChangeFontFamily,
  } = props;

  const contentRef = useRef(null);

  const [openOptions, setOpenOptions] = useState(false);
  const [mounted, setMounted] = useState(false);

  const toggleOptions = () => {
    setOpenOptions(!openOptions);
  };

  useEffect(() => {
    contentRef.current.addEventListener("webkitAnimationEnd", () => {
      if (openOptions) {
        contentRef.current.style.overflow = "visible";
      } else {
        contentRef.current.style.overflow = "hidden";
      }
    });

    if (openOptions) {
      contentRef.current.style.maxHeight = "fit-content";
      contentRef.current.style.WebkitAnimation = `${styles.expand} 0.2s`;
    } else {
      if (mounted) {
        contentRef.current.style.WebkitAnimation = `${styles.collapse} 0.2s`;
      }

      contentRef.current.style.overflow = "hidden";
      contentRef.current.style.maxHeight = "0px";
    }
  }, [openOptions, mounted]);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className={styles.containerPlayerName}>
      <div className={styles.options}>
        {background && (
          <div className={styles.backgroundInputContainer}>
            <span>{backgroundLabel}</span>

            <div className={styles.backgroundInput}>
              <BackgroundColor
                handleChange={handleChangeBackground}
                background={
                  playerNameStyles.background ||
                  playerNameStyles.background_color
                }
                skew
              />
            </div>
          </div>
        )}
        <div className={styles.textStylesOptions}>
          <div className={styles.textStylesOptionsHead} onClick={toggleOptions}>
            <span>{stylesLabel}</span>
            <img
              src={arrowDown}
              alt="expand"
              className={openOptions ? styles.rotate : ""}
            />
          </div>
          <div
            ref={contentRef}
            className={`${styles.textStylesOptionsContent} ${
              openOptions ? styles.open : ""
            }`}
          >
            <div className={styles.line}></div>
            <div className={styles.inputs}>
              <div className={styles.inputWrapper}>
                <label>Font Size</label>
                <SelectLSC
                  optionValues={sizeFont}
                  optionRealValues={sizeFontReals}
                  inputValue={
                    playerNameStyles.fontSize || playerNameStyles.font_size
                  }
                  onChange={handleOnSelect}
                />
              </div>
              {fontWeight && (
                <div className={styles.inputWrapper}>
                  <label>Bold</label>
                  <ButtonSelect
                    label={"B"}
                    onChange={selectBold}
                    selected={
                      playerNameStyles.fontWeight === "700" ||
                      playerNameStyles.font_weight === "700" ||
                      playerNameStyles.fontBold ||
                      playerNameStyles.font_bold
                    }
                  />
                </div>
              )}
              <div className={styles.inputWrapper}>
                <label>Color</label>
                <div className={styles.colorInput}>
                  <BackgroundColor
                    handleChange={handleChangeComplete}
                    background={convertToHex(
                      playerNameStyles.color ||
                        playerNameStyles.fontColor ||
                        playerNameStyles.font_color,
                    )}
                  />
                </div>
              </div>
            </div>

            {!!onChangeFontFamily && (
              <div
                className={styles.inputs}
                style={{
                  marginTop: "10px",
                }}
              >
                <div className={`${styles.inputWrapper} ${styles.fontWrapper}`}>
                  <label>Font Family</label>
                  <Select
                    name="fontFamily"
                    value={
                      playerNameStyles.fontFamily ||
                      playerNameStyles.font_family ||
                      families[0]
                    }
                    onChange={onChangeFontFamily}
                    className="Select"
                  >
                    {families.map((optionValue) => (
                      <MenuItem value={optionValue} key={optionValue}>
                        {optionValue}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            )}

            <div className={styles.playerName}>
              <p>Preview</p>
              <span
                style={{
                  fontWeight:
                    playerNameStyles.fontWeight || playerNameStyles.fontBold
                      ? "700"
                      : "normal",
                  color: convertToHex(
                    playerNameStyles.color || playerNameStyles.fontColor,
                  ),
                  fontSize: playerNameStyles.fontSize,
                  fontFamily: playerNameStyles.fontFamily || "Futura PT Cond",
                }}
              >
                {text || "Player Name"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TextEditor;
